import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import loadable from '@loadable/component';
import { useForceUpdateOnWindowResize } from '@zola/zola-ui/src/hooks/useForceUpdateOnWindowResize';
import { desktopOnly, excludeDesktop } from '@zola/zola-ui/src/styles/emotion/mixins/responsive';
import { getUserContext } from 'selectors/user';
import { usePostAuthDesktopNavRolloutModal } from 'components/common/modals/PostAuthDesktopNavRolloutModal/usePostAuthDesktopNavRolloutModal';
import { useBookingModal } from 'components/common/modals/BookingModal/hooks/useBookingModal';
import { useExposeAuthModal } from 'src/hooks/useExposeAuthModal';
import WhichMobileNavToRender from 'components/WhichMobileNavToRender';

import '../../../stylesheets/nav/WebsiteNav.less';

const NavV2 = loadable(() => import(/* webpackChunkName: "desktop-nav" */ 'components/navV2'), {
  ssr: false,
});
const NavV3 = loadable(
  () => import(/* webpackChunkName: "desktop-nav-v3" */ 'components/navV3/desktop/DesktopWrapper'),
  { ssr: true }
);

/**
 * TODO:
 * Move Homestore into a separate Api route/entry point... actually this should live completely in web-store
 * Move Baby-nav into a separate Api route/entry point... actually this should live completely in web-baby
 * Move Organization JSON-LD to base of Next-apps... see orgShcema.jsx
 *
 */

const NavContainer = () => {
  useForceUpdateOnWindowResize();
  const userContext = useSelector(getUserContext);
  usePostAuthDesktopNavRolloutModal(userContext);
  useBookingModal();

  useExposeAuthModal();

  const showNavV3 = userContext.is_guest || userContext.is_baby_registry_only;
  const Nav = showNavV3 ? NavV3 : NavV2;

  return (
    <Fragment>
      <div css={excludeDesktop}>
        <WhichMobileNavToRender />
      </div>
      <div css={desktopOnly}>
        <Nav />
      </div>
    </Fragment>
  );
};

export default NavContainer;
